import { dfpConfig } from '../../../../Settings/global.json';
import { DeviceHelper } from '../../Core/DeviceHelper';

export function GetConfig() {
    const device = DeviceHelper.GetDevice();

    let config = Object.assign(
        dfpConfig.config,
        dfpConfig.deviceConfig[device]);

    //config.sV = config.sV.replace('{protocol}', document.location.protocol);

    return config;
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Dfp/DfpConfigProvider.js